import * as express from 'express';
import {Logger} from 'common/tool/Logger';

export class HandlerController {
    public static error(_request: express.Request, response: express.Response, error: any): any {
        Logger.error(error);
        const code: number = error.status !== undefined ? Number(error.status) :
            (error.response?.status !== undefined ? Number(error.response.status) : (error.code !== undefined && error.code !== null ? Number(error.code) : 500));
        response.status(!isNaN(code) && code >= 400 && code <= 599 ? code : 500);
        response.json({code: code, message: error.message});
    }
}
